import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withPrefix } from 'gatsby'
import { StoreDispatch, StoreState } from '../../Store'
import { animation } from '../../styles/vars/animation.style'
import { PageTransitionLinkMain, PageTransitionLinkInner } from './index.style'
import { forceTrailingSlash } from '../../utils/utils'
import { colors } from '../../styles/vars/colors.style'
import gsap from 'gsap'

const PageTransitionLink = ({
  children,
  to,
  label,
  color,
  onClick,
  mask = true,
  theme = 'none',
  delay = 0,
  pageTransitionMaskColor = colors.darkBlue,
  ...props
}) => {
  const store = useContext(StoreState)
  const dispatch = useContext(StoreDispatch)

  return (
    <PageTransitionLinkMain
      to={to}
      exit={{
        delay: delay + animation.maskShowDuration,
        length: 0,
        zIndex: 2,
      }}
      entry={{
        delay: 0,
        length: animation.maskHideDuration,
        zIndex: 1,
      }}
      aria-label={label}
      theme={theme}
      color={color}
      {...props}
      onClick={() => {
        if (onClick) {
          onClick()
        }

        const prefixedTo = forceTrailingSlash(withPrefix(to.split('?')[0]))

        dispatch({ type: 'SET_MASK_COLOR', payload: pageTransitionMaskColor })

        if (
          prefixedTo.indexOf(store.pathname) === -1 ||
          prefixedTo.length !== store.pathname.length
        ) {
          gsap.delayedCall(delay, () => {
            dispatch({ type: 'UPDATE_PATHNAME', payload: prefixedTo })
            dispatch({ type: 'SHOW_TRANSITION_MASK' })
          })
        }
      }}
    >
      {mask ? (
        <>
          <PageTransitionLinkInner>{children}</PageTransitionLinkInner>
          <PageTransitionLinkInner>{children}</PageTransitionLinkInner>
        </>
      ) : (
        children
      )}
    </PageTransitionLinkMain>
  )
}

PageTransitionLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  label: PropTypes.string,
  mask: PropTypes.bool,
  theme: PropTypes.oneOf(['outlined', 'filled', 'underline', 'none']),
  delay: PropTypes.number,
  color: PropTypes.string,
  pageTransitionMaskColor: PropTypes.string,
  onClick: PropTypes.func,
}

export default PageTransitionLink
